// Utility functions for tournament management
export const calculateTieBreakers = (players, rounds) => {
  return players.map(player => {
    const opponentIds = rounds.flatMap(r => 
      r.pairings
        .filter(p => p.player1Id === player.id || p.player2Id === player.id)
        .map(p => p.player1Id === player.id ? p.player2Id : p.player1Id)
    ).filter(id => id);

    const opponents = players.filter(p => opponentIds.includes(p.id));
    const omw = opponents.reduce((sum, opp) => sum + (opp.matchWins / Math.max(opp.matchesPlayed, 1)), 0) / Math.max(opponents.length, 1);
    const gwp = player.gameWins / Math.max(player.gamesPlayed, 1);
    const ogw = opponents.reduce((sum, opp) => sum + (opp.gameWins / Math.max(opp.gamesPlayed, 1)), 0) / Math.max(opponents.length, 1);

    return { ...player, omw: omw || 0, gwp: gwp || 0, ogw: ogw || 0 };
  });
};

export const generatePairings = (players, roundNumber, addRandomness = false) => {
  const activePlayers = players.filter(p => !p.dropped);
  const sorted = [...activePlayers].sort((a, b) => {
    if (b.matchPoints !== a.matchPoints) return b.matchPoints - a.matchPoints;
    if (b.omw !== a.omw) return b.omw - a.omw;
    if (b.gwp !== a.gwp) return b.gwp - a.gwp;
    return b.ogw - a.ogw;
  });

  // Grouper les joueurs par points pour ajouter de l'aléatoire dans chaque groupe
  if (addRandomness) {
    const pointGroups = {};
    sorted.forEach(player => {
      const points = player.matchPoints;
      if (!pointGroups[points]) pointGroups[points] = [];
      pointGroups[points].push(player);
    });

    // Mélanger chaque groupe
    Object.keys(pointGroups).forEach(points => {
      const group = pointGroups[points];
      for (let i = group.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [group[i], group[j]] = [group[j], group[i]];
      }
    });

    // Reconstituer la liste triée avec l'aléatoire
    sorted.length = 0;
    Object.keys(pointGroups)
      .sort((a, b) => parseInt(b) - parseInt(a))
      .forEach(points => {
        sorted.push(...pointGroups[points]);
      });
  }

  const pairings = [];
  const paired = new Set();

  for (let i = 0; i < sorted.length; i++) {
    if (paired.has(sorted[i].id)) continue;
    
    for (let j = i + 1; j < sorted.length; j++) {
      if (paired.has(sorted[j].id)) continue;
      
      pairings.push({
        id: `R${roundNumber}-P${pairings.length + 1}`,
        player1Id: sorted[i].id,
        player2Id: sorted[j].id,
        player1Wins: 0,
        player2Wins: 0,
        draws: 0,
        completed: false
      });
      paired.add(sorted[i].id);
      paired.add(sorted[j].id);
      break;
    }
  }

  if (sorted.length % 2 === 1) {
    const unpaired = sorted.find(p => !paired.has(p.id));
    if (unpaired) {
      pairings.push({
        id: `R${roundNumber}-BYE`,
        player1Id: unpaired.id,
        player2Id: null,
        player1Wins: 2,
        player2Wins: 0,
        draws: 0,
        completed: true
      });
    }
  }

  return pairings;
};